"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supporterId = exports.supporter = exports.personCategoryConfig = exports.donorId = exports.donor = exports.PersonCategoryDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var CheckboxDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.CheckboxDefinition;
});

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TextfieldDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var supporter = {
  key: 'supporter',
  type: 'checkbox',
  items: [{
    key: 'supporterCheckbox',
    label: 'a fundraiser or other supporter'
  }],
  ui: {
    classes: 'large'
  },
  validation: []
};
exports.supporter = supporter;
var supporterId = {
  key: 'supporterId',
  label: 'Supporter number',
  ref: 'supporterId',
  placeholder: '',
  type: 'text',
  validation: [{
    supporterId: true
  }]
};
exports.supporterId = supporterId;
var donor = {
  key: 'donor',
  type: 'checkbox',
  items: [{
    key: 'donorCheckbox',
    label: 'on the stem cell donor register'
  }],
  ui: {
    classes: 'large'
  },
  validation: []
};
exports.donor = donor;
var donorId = {
  key: 'donorId',
  label: 'Donor register number',
  type: 'text',
  validation: []
};
exports.donorId = donorId;
var personCategoryConfig = {
  type: 'personCategory',
  fields: [supporter, supporterId, donor, donorId],
  validation: [{
    personCategoryRequired: true
  }]
};
exports.personCategoryConfig = personCategoryConfig;

var PersonCategoryDefinition = _flowRuntime["default"].type("PersonCategoryDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("personCategory")))));

exports.PersonCategoryDefinition = PersonCategoryDefinition;